import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import {
  Business as BusinessIcon,
  Person as ProfileIcon,
  Home as HomeIcon,
} from "@mui/icons-material";

function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#1e293b",
        color: "white",
        py: { xs: 2, sm: 3 },
        px: { xs: 2, sm: 3 },
        mt: "auto",
        textAlign: "center",
        width: "100%",
        position: "relative",
        left: 0,
        right: 0,
      }}
    >
      {/* Navigation Links */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: { xs: 2, sm: 4 },
          mb: 2,
          flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
      >
        <Link
          to="/Business-settings"
          style={{
            color: "inherit",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontSize: isMobile ? "0.75rem" : "0.875rem",
          }}
        >
          <BusinessIcon sx={{ fontSize: { xs: 16, sm: 20 } }} />
          <Typography variant={isMobile ? "caption" : "body2"}>
            Business Setup
          </Typography>
        </Link>

        <Link
          to="/profile"
          style={{
            color: "inherit",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontSize: isMobile ? "0.75rem" : "0.875rem",
          }}
        >
          <ProfileIcon sx={{ fontSize: { xs: 16, sm: 20 } }} />
          <Typography variant={isMobile ? "caption" : "body2"}>
            Profile
          </Typography>
        </Link>

        <Link
          to="/dashboard"
          style={{
            color: "inherit",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontSize: isMobile ? "0.75rem" : "0.875rem",
          }}
        >
          <HomeIcon sx={{ fontSize: { xs: 16, sm: 20 } }} />
          <Typography variant={isMobile ? "caption" : "body2"}>Home</Typography>
        </Link>
      </Box>

      {/* Version and Copyright */}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant={isMobile ? "caption" : "body2"}
          sx={{ mb: 1, color: "#94a3b8" }}
        >
          Software Version (15.0)
        </Typography>
        <Typography variant="caption" color="#64748b">
          © 2025 PrintForMee. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
